import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private showHeaderFooterSubject = new BehaviorSubject<boolean>(true);
  public showHeaderFooter$: Observable<boolean> = this.showHeaderFooterSubject.asObservable();

  constructor(private router: Router) {
    this.initializeRouteListener();
  }

  private initializeRouteListener(): void {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event) => {
      this.updateLayoutVisibility(event.url);
    });
  }

  private updateLayoutVisibility(url: string): void {
    // Routes where header and footer should be hidden
    const hideHeaderFooterRoutes = [
      '/change-password',
      '**',
    ];

    const shouldHide = hideHeaderFooterRoutes.some(route => 
      url === route || url.startsWith(route + '/')
    );

    this.showHeaderFooterSubject.next(!shouldHide);
  }

  // Manual control methods if needed
  public hideHeaderFooter(): void {
    this.showHeaderFooterSubject.next(false);
  }

  public showHeaderFooter(): void {
    this.showHeaderFooterSubject.next(true);
  }

  public getShowHeaderFooter(): boolean {
    return this.showHeaderFooterSubject.value;
  }
}
